// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePoolListMineBody = {
  cursor?: string | null;
  limit?: number | null;
  view?: "current" | "archived" | null;
};

export type typePoolListMineOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      poolId: string;
      name: string;
      sportKey: string;
      leagueKey: string;
      seasonYear: number;
      contestType: "survivor" | "squares" | "stripCard" | "pickem";
      poolRole: "owner" | "admin" | "member";
      membershipStatus: "pending" | "active" | "suspended";
      poolStatus: "active" | "archived";
      statusLabel: string;
      activeMemberCount: number;
      bannerImageUrl?: string | null;
      creatorHandle?: string | null;
      isArchivedByMe: boolean;
    }[];
    nextCursor?: string | null;
  };
};

export type typePoolListMineOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolListMineOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolListMineOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPoolListMineBody = {
  type: "object",
  properties: {
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
    view: {
      oneOf: [
        { type: "string", enum: ["current", "archived"] },
        { enum: [null] },
      ],
    },
  },
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPoolListMine(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPoolListMineBody);
  }

  return async function postPoolListMine(
    payload: typePoolListMineBody,
  ): Promise<typePoolListMineOutput200 | typePoolListMineOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPoolListMine" failed before calling the network. #b124e14285ec`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#b124e14285ec" },
        },
        data: null,
      } as typePoolListMineOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pool/list-mine`,
      httpMethod: "POST",
      options,
    })) as typePoolListMineOutput200 | typePoolListMineOutput400;
  };
}
